/**
 * OrbDocCoreConceptsPagesENDocScreenView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocCoreConceptsPagesENDocScreen
 */

import { useOrbDocCoreConceptsPagesENDocScreenLogic } from '@/hooks/traits/useOrbDocCoreConceptsPagesENDocScreenLogic';
import type { OrbDocCoreConceptsPagesENDocScreenConfig } from '@/hooks/traits/useOrbDocCoreConceptsPagesENDocScreenLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocCoreConceptsPagesENDocView as OrbDocCoreConceptsPagesENDocViewEntity } from '@app/shared';
import { OrbDocCoreConceptsPagesENDocBodyView } from '@/components/traits/OrbDocCoreConceptsPagesENDocBodyView';
import { OrbDocCoreConceptsPagesENDocFooterView } from '@/components/traits/OrbDocCoreConceptsPagesENDocFooterView';
import { OrbDocCoreConceptsPagesENDocHeaderView } from '@/components/traits/OrbDocCoreConceptsPagesENDocHeaderView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocCoreConceptsPagesENDocScreenViewProps {
  config?: Partial<OrbDocCoreConceptsPagesENDocScreenConfig>;
}

export function OrbDocCoreConceptsPagesENDocScreenView({ config: propsConfig }: OrbDocCoreConceptsPagesENDocScreenViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocCoreConceptsPagesENDocScreenLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocCoreConceptsPagesENDocView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocCoreConceptsPagesEN" trait="OrbDocCoreConceptsPagesENDocScreen">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="OrbDocCoreConceptsPagesENDocScreen">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><OrbDocCoreConceptsPagesENDocHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocCoreConceptsPagesENDocBodyView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocCoreConceptsPagesENDocFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default OrbDocCoreConceptsPagesENDocScreenView;
